import api, { GetApiReturn, handleApiError, ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';

export type ReadEventoInstitucionalDto = {
  id: number;
  titulo: string;
  descricao?: string | null;
  data_inicial: string;
  data_final: string;
  editadoPor?: { id?: number; username?: string; nome?: string };
  editadoEm?: string;
};

export type CreateEventoInstitucionalDto = {
  id?: number;
  titulo: string;
  descricao?: string | null;
  data_inicial: string;
  data_final: string;
};

export type RelatorioEventoInstitucionalAusenciaDto = {
  periodoId: number;
  defensorNome: string;
  tipo: number;
  data_inicial: string;
  data_final: string;
};

export type RelatorioEventoInstitucionalItemDto = {
  id: number;
  titulo: string;
  descricao?: string | null;
  data_inicial: string;
  data_final: string;
  ausencias: RelatorioEventoInstitucionalAusenciaDto[];
};

export async function GetEventosInstitucionais(skip = 0, take = 100, where?: string) {
  try {
    const response = await api.get(Endpoints.EVENTO_INSTITUCIONAL, {
      params: { skip, take, where: where || undefined },
    });
    return GetApiReturn<ReadEventoInstitucionalDto>(response.data as any);
  } catch (error) {
    handleApiError(error);
  }
}

export async function GetEventoInstitucional(id: number) {
  try {
    const response = await api.get(`${Endpoints.EVENTO_INSTITUCIONAL}/${id}`);
    return response.data as ReadEventoInstitucionalDto;
  } catch (error) {
    handleApiError(error);
  }
}

export async function SetEventoInstitucional(data: CreateEventoInstitucionalDto) {
  if (data.id != null && data.id > 0) {
    return api
      .put(`${Endpoints.EVENTO_INSTITUCIONAL}/${data.id}`, data)
      .then(() => `Evento "${data.titulo}" atualizado.`)
      .catch((error) =>
        ValidateAxiosError<string>(error, 'Falha ao atualizar o evento institucional.'),
      );
  }
  return api
    .post(Endpoints.EVENTO_INSTITUCIONAL, data)
    .then(() => `Evento "${data.titulo}" cadastrado.`)
    .catch((error) =>
      ValidateAxiosError<string>(error, 'Falha ao cadastrar o evento institucional.'),
    );
}

export async function DeleteEventoInstitucional(id: number) {
  return api
    .delete(`${Endpoints.EVENTO_INSTITUCIONAL}/${id}`)
    .then(() => 'Evento institucional removido.')
    .catch((error) =>
      ValidateAxiosError<string>(error, 'Falha ao remover o evento institucional.'),
    );
}

export async function GetRelatorioEventosInstitucionais(dataInicio?: string, dataFim?: string) {
  try {
    const response = await api.get(`${Endpoints.EVENTO_INSTITUCIONAL}/relatorio`, {
      params: {
        dataInicio: dataInicio || undefined,
        dataFim: dataFim || undefined,
      },
    });
    return response.data as RelatorioEventoInstitucionalItemDto[];
  } catch (error) {
    handleApiError(error);
  }
}
